import './auth.css'
import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { login } from './authActions'
import Row from '../common/layout/row'
import Grid from '../common/layout/grid'
import Messages from '../common/msg/messages'
import Input from '../common/form/inputAuth'
class Auth extends Component {
    
    onSubmit(values) {
        const { login } = this.props
        login(values)
    }
    render() {
        const { handleSubmit } = this.props
        return (
            <div className="login-box">
                <div className="login-logo"><b> Gestão</b> Protheus</div>
                <div className="login-box-body">
                    <p className="login-box-msg">Bem vindo!</p>
                    <form onSubmit={handleSubmit(v => this.onSubmit(v))}>
                        <Field component={Input} type="email" name="email"
                            placeholder="E-mail" icon='envelope' />
                        <Field component={Input} type="password" name="password"
                            placeholder="Senha" icon='lock' />
                        <Row>
                            <Grid cols="4">
                                <button type="submit"
                                    className="btn btn-primary btn-block btn-flat">
                                    {'Entrar'}
                                </button>
                            </Grid>
                        </Row>
                    </form>
                    <p className="login-report-link">
                        <a
                            href="https://app.powerbi.com/groups/04c61ba6-49e1-4d92-b4a2-382e5b1f65cc/reports/50ba4f2a-29c2-4578-a845-3c02d873b046?ctid=faf0e88f-174b-4b32-ba6c-59c6cc51e7b8&pbi_source=linkShare"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {'Acesso ao novo gest\u00e3o protheus'}
                        </a>
                    </p>
                    <br />
                </div>
                <Messages />
            </div>

        )
    }
}

Auth = reduxForm({ form: 'authForm' })(Auth)
const mapDispatchToProps = dispatch => bindActionCreators({ login },
    dispatch)
export default connect(null, mapDispatchToProps)(Auth)
